import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { formatApiError } from "../../lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Connexion réussie");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err, "Connexion impossible"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm rounded-3xl border border-gold/30 bg-white p-8 shadow-2xl">
        <div className="flex flex-col items-center text-center">
          <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-ink text-gold">
            <Lock className="h-6 w-6" />
          </span>
          <h1 className="mt-4 font-display text-2xl font-extrabold text-slate-900">Espace propriétaire</h1>
          <p className="mt-1 text-sm text-slate-500">Oxyservices — administration</p>
        </div>
        <form onSubmit={submit} className="mt-7 space-y-4">
          <div>
            <label className="label-oxy" htmlFor="admin-email">Identifiant ou email</label>
            <input id="admin-email" data-testid="admin-login-email" type="text" required autoComplete="username"
              value={email} onChange={(e) => setEmail(e.target.value)} className="input-oxy" placeholder="Votre identifiant" />
          </div>
          <div>
            <label className="label-oxy" htmlFor="admin-password">Mot de passe</label>
            <input id="admin-password" data-testid="admin-login-password" type="password" required autoComplete="current-password"
              value={password} onChange={(e) => setPassword(e.target.value)} className="input-oxy" placeholder="••••••••" />
          </div>
          <button type="submit" data-testid="admin-login-submit" disabled={loading}
            className="btn-gold w-full disabled:opacity-60">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
